<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill-rule="evenodd" d="M4 3a1 1 0 011-1h9a1 1 0 01.707.293l5 5A1 1 0 0120 8v13a1 1 0 01-1 1H5a1 1 0 01-1-1V3zm2 1v16h12V9h-4a1 1 0 01-1-1V4H6zm9 1.414L16.586 7H15V5.414zM9 16a1 1 0 100 2h6a1 1 0 100-2H9zm-1-3a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zm1-5a1 1 0 000 2h2a1 1 0 100-2H9z"/></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"/></clipPath></defs></svg>